import React, { FC } from 'react';
import { useLazyLoading } from '../_common';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Loading } from '../_common';
import moment from 'moment';
import { faEllipsisV, faComment, faSms } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';

interface LooseObject {
    [key: string]: any;
}

interface DriverConversationMessageListProps {
    conversations: LooseObject[];
    refetch?: () => void;
    isLoading: boolean;
    isEndOfResults: boolean;
    history: any;
    onLoadMore: () => void;
    markAsReadHandler: (conversationId: string, messageId: number, id: number) => void;
    markAsUnReadHandler: (conversationId: string, messageId: number, id: number) => void;
}

const DriverConversationMessageList: FC<DriverConversationMessageListProps> = ({
    conversations,
    refetch,
    isLoading,
    isEndOfResults,
    history,
    onLoadMore,
    markAsReadHandler,
    markAsUnReadHandler,
}: DriverConversationMessageListProps): React.ReactElement => {
    const { handleScroll } = useLazyLoading('messageConversation', isLoading, isEndOfResults, onLoadMore, true);

    if (isLoading) {
        return <Loading />;
    }
    const total = conversations.length;
    // let loadId;
    // let driverDataSring = localStorage.getItem('driverData');
    // if (driverDataSring) {
    //     let driverData = JSON.parse(driverDataSring);
    //     loadId = driverData.loadId;
    // }
    return (
        <div className="Message-Conversation justify-content-center my-auto align-self-center">
            <div className="Message-Conversation-Group" id="messageConversation" onScroll={handleScroll}>
                {conversations.map((conversation, index) => (
                    <>
                        {!conversation.isFromDriver ? (
                            <div
                                className={
                                    index == 0
                                        ? 'msg first dispatch ml-auto justify-content-end'
                                        : index == total - 1
                                        ? 'msg last dispatch ml-auto justify-content-end'
                                        : 'msg dispatch ml-auto justify-content-end'
                                }
                                key={conversation.id}
                            >
                                {!(conversation.loadId == 0 || conversation.loadId == null) && (
                                    <div className="loadid">
                                        <strong>LOAD ID:</strong> {conversation.loadId}{' '}
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={`/load_profile/${conversation.loadId}`}
                                        >
                                            <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                                        </Link>
                                    </div>
                                )}
                                <div className="detail">
                                    <span
                                        title="Mark as Unread"
                                        className="conv-icon float-left"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            if (conversation.lastMessageRead > 0) {
                                                markAsUnReadHandler(
                                                    conversation.conversationId,
                                                    conversation.messageId,
                                                    conversation.id,
                                                );
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEllipsisV} color="gray" />
                                    </span>

                                    <span className="conv-icon float-left">
                                        <FontAwesomeIcon
                                            icon={conversation.message.messageType == 'Sms' ? faSms : faComment}
                                        />
                                    </span>

                                    <span className="by">
                                        {conversation.isFromDriver
                                            ? conversation.driverName || conversation.driver.name
                                            : 'Dispatch'}
                                    </span>
                                    {/* {(conversation.lastMessageRead == 0 || conversation.lastMessageRead == null) && (
                                        <span className="status unread"></span>
                                    )} */}
                                    <p
                                        className="message"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            if (
                                                conversation.lastMessageRead == 0 ||
                                                conversation.lastMessageRead == null
                                            ) {
                                                markAsReadHandler(
                                                    conversation.conversationId,
                                                    conversation.messageId,
                                                    conversation.id,
                                                );
                                            }
                                        }}
                                    >
                                        {conversation.message.bodyMessage}
                                    </p>
                                </div>
                                <div className="date">
                                    {moment
                                        .utc(conversation.creationDate)
                                        .local()
                                        .format('LLL')}
                                </div>
                            </div>
                        ) : (
                            <div
                                className={
                                    index == 0 ? 'msg first other' : index == total - 1 ? 'msg last other' : 'msg other'
                                }
                            >
                                {!(conversation.loadId == 0 || conversation.loadId == null) && (
                                    <div className="loadid">
                                        <strong>LOAD ID:</strong> {conversation.loadId}{' '}
                                        <Link
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            to={`/load_profile/${conversation.loadId}`}
                                        >
                                            <FontAwesomeIcon icon={['fas', 'external-link-alt']} />
                                        </Link>
                                    </div>
                                )}

                                <div className="detail">
                                    <span
                                        title="Mark as Unread"
                                        className="conv-icon float-right"
                                        style={{ cursor: 'pointer', marginLeft: '5px' }}
                                        onClick={() => {
                                            if (conversation.lastMessageRead > 0) {
                                                markAsUnReadHandler(
                                                    conversation.conversationId,
                                                    conversation.messageId,
                                                    conversation.id,
                                                );
                                            }
                                        }}
                                    >
                                        <FontAwesomeIcon icon={faEllipsisV} color="gray" />
                                    </span>
                                    <span className="conv-icon float-right">
                                        <FontAwesomeIcon
                                            icon={conversation.message.messageType == 'Sms' ? faSms : faComment}
                                        />
                                    </span>

                                    <span className="by">
                                        {conversation.isFromDriver
                                            ? conversation.driverName || conversation.driver.name
                                            : 'Dispatch'}
                                    </span>
                                    {(conversation.lastMessageRead == 0 || conversation.lastMessageRead == null) && (
                                        <span className="status unread"></span>
                                    )}
                                    <p
                                        className="message"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            if (
                                                conversation.lastMessageRead == 0 ||
                                                conversation.lastMessageRead == null
                                            ) {
                                                markAsReadHandler(
                                                    conversation.conversationId,
                                                    conversation.messageId,
                                                    conversation.id,
                                                );
                                            }
                                        }}
                                    >
                                        {conversation.message.bodyMessage}
                                    </p>
                                </div>
                                <div className="date">
                                    {moment
                                        .utc(conversation.creationDate)
                                        .local()
                                        .format('LLL')}
                                </div>
                            </div>
                        )}
                    </>
                    // </div>
                ))}
            </div>
        </div>
    );
};

export default DriverConversationMessageList;
